"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePDPSearchParams = void 0;
var _reactRouterDom = require("react-router-dom");
/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

const usePDPSearchParams = productId => {
  const {
    search
  } = (0, _reactRouterDom.useLocation)();
  const allParams = new URLSearchParams(search);
  const productParams = new URLSearchParams(allParams.get(productId) || '');
  return [allParams, productParams];
};
exports.usePDPSearchParams = usePDPSearchParams;